import React from "react"

const Hamburger = ({ width="20", height="14", viewBox="0 0 20 14" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5.826A.83.83 0 0018.666 0L.85.08.753.086A.83.83 0 00.857 1.74l17.817-.08.097-.006A.83.83 0 0019.5.826zM1.05 5.986l16.99.032c.579 0 1.047.366 1.045.816-.001.418-.407.761-.928.807l-.122.005-16.99-.03C.466 7.613-.001 7.248 0 6.798c.001-.45.471-.813 1.05-.812zm17.62 5.624a.83.83 0 01.097 1.654l-.097.006H.854a.83.83 0 01-.097-1.654l.097-.006H18.67z"
        fill="#fff"
      />
    </svg>
  )
}

export default Hamburger